/* eslint-disable promise/param-names */
import Vue from 'vue'
import {
  AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_FORBIDDEN
} from '@/store/actions/auth'
import { USER_REQUEST } from '@/store/actions/user'

const state = {
  token: localStorage.getItem('user_token') || '',
  status: ''
}

const getters = {
  isAuthenticated: state => (!!state.token || process.vars.AUTH_FAKE_AUTH),
  authStatus: state => state.status
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, authResponse) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      commit(AUTH_SUCCESS, authResponse.body)
      dispatch(USER_REQUEST, authResponse.body.access_token)
      resolve()
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('user_token')
      commit(AUTH_LOGOUT)
      resolve()
    })
  },
  [AUTH_FORBIDDEN]: ({commit, dispatch, error}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_FORBIDDEN, error)
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, creds) => {
    state.status = 'success'
    Vue.http.headers.common['Authorization'] = `Bearer ${creds.access_token}`
    localStorage.setItem('user_token', creds.access_token)
    state.token = creds.access_token
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  },
  [AUTH_FORBIDDEN]: (state, error) => {
    state.status = 'forbidden'
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
